import { type ButtonHTMLAttributes } from "react";
import cn from "classnames";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import styles from "./Button.module.scss";

type ButtonVariant = "primary" | "secondary" | "ghost" | "primary-alt" | "secondary-alt";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  loading?: boolean;
  animated?: boolean;
  classNameContent?: string;
  shineAnimation?: boolean;
  shineAnimationDelay?: number;
  compactHeight?: boolean;
}

export const Button = ({
  variant = "primary",
  fullWidth = false,
  loading = false,
  disabled = false,
  children,
  animated = false,
  className = "",
  classNameContent = "",
  shineAnimation = false,
  shineAnimationDelay = 6,
  compactHeight = false,
  ...rest
}: ButtonProps) => {
  return (
    <button
      className={cn(
        styles.button,
        styles[variant],
        {
          [styles.fullWidth]: fullWidth,
          [styles.animated]: animated && !disabled && !loading,
          [styles.loading]: loading,
          [styles.shineAnimation]: shineAnimation && !disabled && !loading,
          [styles.compactHeight]: compactHeight
        },
        className
      )}
      style={
        shineAnimation && !disabled && !loading
          ? ({ "--shine-delay": `${shineAnimationDelay}s` } as React.CSSProperties)
          : undefined
      }
      disabled={disabled || loading}
      {...rest}
    >
      <span className={cn(styles.content, classNameContent)}>{children}</span>

      {loading && (
        <span className={styles.loader}>
          <Spin indicator={<LoadingOutlined spin />} style={{ color: "#fff" }} />
        </span>
      )}
    </button>
  );
};
